<template>
	<b-modal ref="modal" class="modal-primary" @ok="onOkModal" :title="modalTitle" :ok-title="modalOkTitle" :cancel-title="modalCancelTitle" :busy="modalIsBusy">
		<loading :active.sync="isLoading"></loading>
		<b-form ref="form">
			<b-row>
				<b-col sm="6">
					<b-form-group
						:invalid-feedback="invalidFeedback_firstName"
						:state="state_firstName">
						<label for="first_name">Ime</label>
						<b-form-input type="text" id="first_name" v-model="modalUser.first_name" required></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6">
					<b-form-group
						:invalid-feedback="invalidFeedback_lastName"
						:state="state_lastName">
						<label for="last_name">Priimek</label>
						<b-form-input type="text" id="last_name" v-model="modalUser.last_name" required></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						:invalid-feedback="invalidFeedback_email"
						:state="state_email">
						<label for="email">Email</label>
						<b-form-input ref="emailInputRef" type="email" id="emailInputId" v-model="modalUser.email" :disabled="!modalIsNew" required autocomplete="off"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col sm="6">
					<b-form-group 
						:invalid-feedback="invalidFeedback_password"
						:state="state_password">
						<label for="password">Geslo</label>
						<b-form-input type="password" id="password" v-model="modalUser.password" autocomplete="off"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6">
					<b-form-group
						:invalid-feedback="invalidFeedback_password2"
						:state="state_password2">
						<label for="first_name">Geslo (ponovno)</label>
						<b-form-input type="password" id="password2" v-model="modalUser.password2" autocomplete="off"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group>
						<label for="match_pattern">Ujemanje (DISTRI NET)</label>
						<b-form-input type="text" id="match_pattern" v-model="modalUser.match_pattern"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col sm="2">
					<b-form-group>
						<label for="role_user">Vloga</label>
					</b-form-group>
				</b-col>
				<b-col sm="5">
					<b-form-radio-group id="role_user" v-model="modalUser.role" :options="role_options"></b-form-radio-group>
				</b-col>
			</b-row>
			<b-row class="mt-2" v-if="this.modalUser.id > 0">
				<b-col>
					<b-card class="mb-0" header="Podrobnosti">
						<div class="mb-2">IP zadnjega dostopa: <b>{{ modalUser.last_access_ip_readonly }}</b></div>
						<div class="mb-2" v-html="this.timestampIzpis('Zadnji dostop', modalUser.last_access_at_readonly)"/>
						<div class="mb-2" v-html="this.timestampIzpis('Dodan', modalUser.created_at_readonly)"/>
					</b-card>
				</b-col>
			</b-row>
			<app-mbox v-if="modalErrorMsg" :text="modalErrorMsg" @dismissed="clear_error_msg"></app-mbox>
		</b-form>
	</b-modal>
</template>
<style>
</style>
<script>
import service from '@/service';
import { format } from 'date-fns';
import settings from '@/settings.js';
import Loading from 'vue-loading-overlay';

export default {
	name: 'editusermodal',
	components: {
		Loading
	},
	methods: {
		showModal: function (value) {
			if (value == null) {
				this.modalErrorMsg = null;
				this.modalIsNew = true;
				this.modalTitle = 'Dodaj uporabnika';
				this.modalOkTitle = 'Dodaj';
				this.modalUser.id = 0;
				this.modalUser.first_name = '';
				this.modalUser.last_name = '';
				this.modalUser.email = '';
				this.modalUser.password = '';
				this.modalUser.password2 = '';
				this.modalUser.match_pattern = '';
				this.modalUser.role = 0;
			} else {
				this.modalErrorMsg = null;
				this.modalIsNew = false;
				this.modalTitle = 'Uredi uporabnika (' + value.first_name + ' ' + value.last_name + ')';
				this.modalOkTitle = 'Shrani';
				this.modalUser.id = value.id;
				this.modalUser.first_name = value.first_name;
				this.modalUser.last_name = value.last_name;
				this.modalUser.email = value.email;
				this.modalUser.password = '';
				this.modalUser.password2 = '';
				this.modalUser.match_pattern = value.match_pattern;
				this.modalUser.role = value.role;
				this.modalUser.last_access_ip_readonly = value.last_access_ip;
				this.modalUser.last_access_at_readonly = value.last_access_at;
				this.modalUser.created_at_readonly = value.created_at;
			}
			this.$refs.modal.show();
		},
		onOkModal: function (evt) {
			evt.preventDefault();
			if (!this.validateForm) {
				this.modalErrorMsg = 'Označena polja so nepravilno izpolnjena';
				return;
			}
			this.modalIsBusy = true;
			this.modalErrorMsg = null;
			this.isLoading = true;
			service.addUser(this.modalUser)
				.then(response => {
					this.modalIsBusy = false;
					this.isLoading = false;
					if (response['message'] === 'updated' && !this.modalIsNew) {
						this.$emit('user_edit', response['user']);
						this.$refs.modal.hide();
					} else if (response['message'] === 'added' && this.modalIsNew) {
						this.$emit('user_add', response['user']);
						this.$refs.modal.hide();
					} else {
						this.modalErrorMsg = 'Neveljaven odziv strežnika';
						console.error('Neveljaven response message: ' + response.data['message']);
					}
				})
				.catch(error => {
					this.modalIsBusy = false;
					this.isLoading = false;
					if (error.response) {
						// Request made and server responded
						if (error.response.data.message === settings.errorMessages.serverSideValidationError) {
							this.modalErrorMsg = 'Napaka pri validaciji na strežniku!';
							console.error(error.response.data.message + ': ', error.response.data.errors);
						} else if (error.response.data.message === 'emailInUse') {
							this.modalErrorMsg = 'Email že obstaja!';
							console.error(error.response.data.message);
						} else if (error.response.data.message === 'userNotExists') {
							this.modalErrorMsg = 'Uporabnik ne obstaja!';
							console.error(error.response.data.message);
						} else if (error.response.data.message === settings.errorMessages.invalidRole) {
							this.showError('Uporabnik nima pravice odstranjevanja uporabnikov!');
							console.error(error.response.data.message);
						} else if (error.response.data.message === settings.errorMessages.PDOException) {
							this.modalErrorMsg = 'Napaka na strežniku!';
							console.error(error.response.data.message, 'details in .ex');
						} else {
							this.modalErrorMsg = 'Neznana napaka na strežniku!';
							console.error(error.response.data.message);
						}
					} else if (error.request) {
						// The request was made but no response was received
						console.log('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
		},
		clear_error_msg: function (event) {
			this.modalErrorMsg = null;
		},
		timestampIzpis: function (prefix, timestamp) {
			let result = '';
			if (timestamp) {
				let datum = format(timestamp.substring(0, 10), settings.viewDtFormat);
				let ura = timestamp.substring(11, 19);
				result = prefix + ' dne <b>' + datum + '</b> ob ' + ura;
			}
			return result;
		}
	},
	computed: {
		state_password () {
			if (this.modalIsNew) {
				if (this.modalUser.password.length >= 6) {
					this.modalErrorMsg = null;
					return true;
				}
				return false;
			} else {
				if (this.modalUser.password.length === 0 || this.modalUser.password.length >= 6) {
					this.modalErrorMsg = null;
					return true;
				}
				return false;
			}
		},
		invalidFeedback_password () {
			if (this.modalIsNew) {
				if (this.modalUser.password.length < 6) {
					return 'Geslo mora vsebovati vsaj 6 znakov';
				} else {
					return '';
				}
			} else {
				if (this.modalUser.password.length === 0) {
					return '';
				}
				if (this.modalUser.password.length > 0 && this.modalUser.password.length < 6) {
					return 'Za spremembo gesla mora geslo mora vsebovati vsaj 6 znakov';
				}
			}
		},
		state_password2 () {
			if (this.modalIsNew) {
				if (this.modalUser.password === this.modalUser.password2) {
					this.modalErrorMsg = null;
					return true;
				}
				return false;
			} else {
				if ((this.modalUser.password.length === 0 || this.modalUser.password.length >= 6) && this.modalUser.password === this.modalUser.password2) {
					this.modalErrorMsg = null;
					return true;
				}
				return false;
			}
		},
		invalidFeedback_password2 () {
			if (this.modalIsNew) {
				if (this.modalUser.password.length === 0 && this.modalUser.password2.length < 6) {
					return 'Geslo mora vsebovati vsaj 6 znakov';
				}
				if (this.modalUser.password !== this.modalUser.password2) {
					return 'Gesli se ne ujemata';
				}
				return '';
			} else {
				if (this.modalUser.password.length === 0 && this.modalUser.password2.length < 6) {
					return 'Geslo mora vsebovati vsaj 6 znakov';
				}
				if ((this.modalUser.password.length > 0 || this.modalUser.password2.length > 0) && this.modalUser.password !== this.modalUser.password2) {
					return 'Gesli se ne ujemata';
				}
				return '';
			}
		},
		state_firstName () {
			if (this.modalUser.first_name.length > 0) {
				this.modalErrorMsg = null;
				return true;
			}
			return false;
		},
		invalidFeedback_firstName () {
			if (this.modalUser.first_name.length === 0) {
				return 'Ime je obvezno';
			}
			return '';
		},
		state_lastName () {
			if (this.modalUser.last_name.length > 0) {
				this.modalErrorMsg = null;
				return true;
			}
			return false;
		},
		invalidFeedback_lastName () {
			if (this.modalUser.last_name.length === 0) {
				return 'Priimek je obvezen';
			}
			return '';
		},
		state_email () {
			let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (this.modalUser.email.length > 0 && emailRegex.test(this.modalUser.email)) {
				this.modalErrorMsg = null;
				return true;
			}
			return false;
		},
		invalidFeedback_email () {
			if (this.modalUser.email.length === 0) {
				return 'Email je obvezen';
			}
			let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!emailRegex.test(this.modalUser.email)) {
				return 'Email je nepravilne oblike';
			}
			return '';
		},
		validateForm: function () {
			if (this.state_password && this.state_password2 && this.state_firstName && this.state_lastName && this.state_email) {
				return true;
			}
			return false;
		}
	},
	data: function () {
		return {
			isLoading: false,
			modalErrorMsg: null,
			modalIsBusy: false,
			modalTitle: 'Dodaj uporabnika',
			modalOkTitle: 'Dodaj',
			modalCancelTitle: 'Prekliči',
			modalIsNew: true,
			modalUser: {
				id: 0,
				first_name: '',
				last_name: '',
				email: '',
				password: '',
				password2: '',
				match_pattern: '',
				role: 0
			},
			role_options: [
				{ text: 'Prodajalec', value: 0 },
				{ text: 'Komercialni sekretar', value: 1 },
				{ text: 'Računovodja', value: 3 },
				{ text: 'Moderator', value: 4 },
				{ text: 'Administrator', value: 5 },
				{ text: 'Skrbnik gum', value: 11 },
				{ text: 'Servis', value: 12 },
				{ text: 'Poprodaja', value: 13 }
			]
		};
	}
};
</script>


// WEBPACK FOOTER //
// src/components/EditUserModal.vue